/* Busca client-side de planos (ADR-0702): as listas (públicos e negociados) são arrays
   completos (sem cursor), então filtramos em memória por nome, tier ou lookup key. Predicado
   estrutural — serve PlanDto e TargetedPlanDto (ambos expõem displayName/tier/lookupKey).
   Fonte única compartilhada por PublicSection e TargetedSection. `query` já vem normalizada
   (trim + lowercase) pelo call site. */
export function matchesQuery(
  plan: { readonly displayName: string; readonly tier: string; readonly lookupKey: string },
  query: string,
): boolean {
  return (
    plan.displayName.toLowerCase().includes(query) ||
    plan.tier.toLowerCase().includes(query) ||
    plan.lookupKey.toLowerCase().includes(query)
  );
}
